<kendo-card class="m-5" role="button" (click)="router.navigateByUrl('admin/settings/translations')">
    <kendo-card-header class="bg-light text-center text-primary">
        <h3>{{'Translations' | translate}}</h3>
    </kendo-card-header>
    <kendo-card-body class="p-5 text-center h1 ">
        <i class="fas fa-language p-5 text-white bg-primary"></i>
    </kendo-card-body>
</kendo-card>